import React, { useState, useEffect } from 'react';
import OrgUserService from '../../../services/orgUser.service';
import { toast } from 'react-toastify';
import '../../../styles/dashboard/OrgUser/ActivityLogs.css';

export default function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0 });

  const formatDetails = (details) => {
    if (!details) return null;
    if (typeof details === 'string') return details;
    if (typeof details === 'object') {
      return Object.entries(details)
        .map(([k, v]) => `${k}: ${typeof v === 'object' ? JSON.stringify(v) : v}`)
        .join(' | ');
    }
    return String(details);
  };

  useEffect(() => {
    fetchActivityLogs();
  }, [pagination.page]);

  const fetchActivityLogs = async () => {
    try {
      setLoading(true);
      const response = await OrgUserService.getActivityLogs(pagination.page, pagination.limit);
      setLogs(response.data || []);
      if (response.pagination) {
        setPagination(prev => ({ ...prev, total: response.pagination.total }));
      }
    } catch (error) {
      console.error('Error fetching activity logs:', error);
      toast.error('Failed to load activity logs');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="activity-logs-page">
        <div className="loading">Loading activity logs...</div>
      </div>
    );
  }

  return (
    <div className="activity-logs-page">
      <div className="page-header">
        <div>
          <h1>Activity Logs</h1>
          <p>Track all your account activities</p>
        </div>
      </div>

      <div className="logs-container">
        <div className="logs-timeline">
          {logs.length === 0 ? (
            <div className="empty-state">
              <p>No activity logs found</p>
            </div>
          ) : (
            logs.map((log) => (
            <div key={log.id} className="log-item">
              <div className="log-header">
                <h3 className="log-action">{log.action}</h3>
                <span className="log-timestamp">{new Date(log.createdAt).toLocaleString()}</span>
              </div>
              {formatDetails(log.details) && (
                <p className="log-details">{formatDetails(log.details)}</p>
              )}
              <div className="log-meta">
                <span className="log-meta-item">🌐 IP: {log.ipAddress}</span>
              </div>
            </div>
          ))
          )}
        </div>
      </div>
    </div>
  );
}
